import { uiText } from "@/lib/i18n/uiText";
import { useLocation } from "@/lib/router-compat";
import { useEffect } from "react";
import { useSEO } from "@/lib/useSEO";

const NotFound = () => {
  const location = useLocation();

  useSEO({
    title: "Page Not Found (404) | Statlign",
    description: "The page you were looking for could not be found.",
    noindex: true,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{uiText("Oops! Page not found")}</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
           {uiText("Return to Home")} </a>
      </div>
    </div>
  );
};

export default NotFound;
